<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top: 5%; height: 85%; overflow-y: hidden; z-index: 999"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="ruleForm" :model="form">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
          <span>
            {{ dataStu[form.status] ? dataStu[form.status] : '未启用' }}
          </span>
          <!-- <a-select placeholder="请选择状态" v-model="form.status" v-else :disabled="disabled">
            <a-select-option v-for="d in dataa" :key="d.value">{{ d.name }}</a-select-option>
          </a-select> -->
        </a-form-model-item>
        <a-form-model-item
          v-if="openType !== 'add' && dataStu[form.status] == '启用'"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="启用时间"
          ref="enableTime"
          prop="enableTime"
          :rules="{
            required: true,
            message: '请选择启用时间',
            trigger: 'change'
          }"
        >
          <a-date-picker
            :disabled="disabled || dataStu[form.status] == '停用'"
            v-model="form.enableTime"
            placeholder="请选择时间"
            :show-time="{ format: 'HH:mm:ss' }"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            :disabled-time="disabledTime"
            @openChange="handleOpenChange"
            :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
          />
          <p style="color: red">注:组建评标委员会(资审委员会)的时间在启用时间之后的项目可选择此专家库。</p>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="专家库名称"
          ref="expertLibraryName"
          prop="expertLibraryName"
          :rules="{
            required: true,
            message: '请输入专家库名称',
            trigger: 'change'
          }"
        >
          <a-input
            :maxLength="50"
            placeholder="请输入专家库名称"
            v-model="form.expertLibraryName"
            :disabled="disabled"
          />
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="菜单权限"
          ref="useMenus"
          prop="useMenus"
          :rules="{
            required: true,
            message: '请输入专家库名称',
            trigger: 'change'
          }"
        >
          <a-checkbox-group @change="onChange" v-model="form.useMenus" :disabled="disabled">
            <a-checkbox value="1"> 专家分类管理 </a-checkbox>
            <a-checkbox value="2"> 专家库管理 </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="设置可操作菜单的用户"
          ref="useMenuUserIds"
          prop="useMenuUserIds"
          :rules="{
            required: true,
            message: '请设置可操作菜单的用户',
            trigger: 'change'
          }"
        >
          <a-select
            v-if="userList.length"
            :disabled="disabled"
            mode="multiple"
            placeholder="设置可操作菜单的用户"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @change="handleChangeuseMenuUserIds"
            @search="handleUserSearch"
            @blur="handleUserBlur"
            v-model="form.useMenuUserIds"
          >
            <a-select-option v-for="d in userList" :key="d.userId"> {{ d.name }}{{ d.deptName }} </a-select-option>
          </a-select>
          <span v-else>人员数据加载中，请稍后...</span>
          <p style="color: red">注:此处设置的用户具有维护专家分类、维护专家的菜单操作权限。</p>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol1"
          :wrapperCol="wrapperCol1"
          label="设置可使用此专家库的用户"
          ref="useLibraryUserIds"
          prop="useLibraryUserIds"
          :rules="{
            required: true,
            message: '请设置可使用此专家库的用户',
            trigger: 'change'
          }"
        >
          <a-select
            v-if="userList.length"
            :disabled="disabled"
            mode="multiple"
            placeholder="设置可使用此专家库的用户"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            v-model="form.useLibraryUserIds"
            @search="handleUserSearch"
            @blur="handleUserBlur"
            @change="handleChangeuseLibraryUserIds"
          >
            <a-select-option v-for="d in userList" :key="d.userId">
              {{ d.name }}
            </a-select-option>
          </a-select>
          <span v-else>人员数据加载中，请稍后...</span>
          <p style="color: red">注:此处设置的用户可在组建评标委员会(资审委员会)时选择此专家库。</p>
        </a-form-model-item>
        <a-form-model-item
          :labelCol="labelCol2"
          :wrapperCol="wrapperCol2"
          label="设置可执行此专家库抽取的用户"
          ref="useExtractUserIds"
          prop="useExtractUserIds"
          :rules="{
            required: true,
            message: '请设置可执行此专家库抽取的用户',
            trigger: 'change'
          }"
        >
          <a-select
            v-if="userList.length"
            :disabled="disabled"
            mode="multiple"
            placeholder="设置可执行此专家库抽取的用户"
            :default-active-first-option="true"
            :show-arrow="true"
            :filter-option="false"
            :not-found-content="null"
            @change="handleChangeuseExtractUserIds"
            @search="handleUserSearch"
            @blur="handleUserBlur"
            v-model="form.useExtractUserIds"
          >
            <a-select-option v-for="d in userList" :key="d.userId">
              {{ d.name }}
            </a-select-option>
          </a-select>
          <span v-else>人员数据加载中，请稍后...</span>
          <p style="color: red">注:此处设置的用户可在项目抽取管理中执行专家抽取操作。</p>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注说明">
          <a-textarea
            :disabled="disabled"
            :rows="5"
            :maxLength="200"
            v-model="form.remark"
            placeholder="请在此填写备注说明，内容不超过200字"
          />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>
<script>
import JImageUpload from '@/components/jeecg/JImageUpload'
import pick from 'lodash.pick'
import { getAction, postAction } from '@/api/manage.js'
import { addZJK, editZJK, checkRoleCodeByAppId, sysInfoall, FileUpload } from '@/api/api'
import CUpload from '@/components/cusComponent/CUpload'
import { ACCESS_TOKEN, APPID } from '@/store/mutation-types'
import Vue from 'vue'
import moment from 'moment'
export default {
  name: 'RoleModal',
  components: {
    JImageUpload,
    CUpload,
    moment
  },
  data() {
    return {
      now: null,
      disabled: false,
      openType: null,
      dataa: [
        {
          name: '启用',
          value: 2
        },
        {
          name: '停用',
          value: 3
        }
      ],
      dataStu: {
        1: '待启用',
        2: '启用',
        3: '停用'
      },
      plainOptions: [
        {
          label: '专家分类管理',
          value: '1'
        },
        {
          label: '专家库管理',
          value: '2'
        }
      ],
      userList: [],
      fileAvatarList: [{}],
      iconGroup: '', //上传图片
      uploadAction: `${window._CONFIG['fileUrl']}/uploader/notChunkUploader`,
      iconUrl: '',
      title: '操作',
      visible: false,
      model: {},
      data: [],
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      labelCol1: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol1: {
        xs: { span: 24 },
        sm: { span: 15 }
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: { status: 1, remark: null, useMenuUserIds: [], useLibraryUserIds: [], useExtractUserIds: [], useMenus: [] },
      headers: {
        authorization: 'authorization-text',
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN),
        appId: Vue.ls.get(APPID)
      },
      uploadData: {
        filename: '',
        attachGroup: '',
        attachName: ''
      }
    }
  },
  created() {
    this.getInfos()
  },
  methods: {
    // 更新当前时间，确保每次打开选择器时获取最新时间
    handleOpenChange(open) {
      if (open) {
        this.now = moment()
      }
    },

    moment,
    // 禁用今天之前的日期
    disabledDate(current) {
      return current && current < this.now.startOf('day')
    },

    onChange(checkedValues) {
      this.form.useMenus = checkedValues
      console.log('checked = ', checkedValues)
      console.log('value = ', this.form.useMenus)
    },
    handleUserSearch(value) {
      // this.userList = []
      this.getUserList(value)
    },
    add() {
      this.disabled = false
      this.visible = true
      // this.userList = []
      this.form = {}
      this.openType = 'add'
      this.getUserList()
    },
    handleUserBlur() {
      this.getUserList()
    },
    getUserList(value) {
      let params = {
        realname: value ? value : '',
        pageNo: 1,
        status: 1,
        pageSize: 1000
      }
      getAction('/api/sys/user/getAtlxUserList', params).then((res) => {
        console.log(res)
        this.userList = []
        if (res.result.records.length) {
          let resp = res.result.records
          resp.map((el) => {
            this.userList.push({
              name: '[' + el.username + ']' + el.realname + '（' + el.deptName + '）',
              userId: el.id
            })
          })
        } else {
          this.getUserList()
        }
      })
    },
    async edit(record, index, flag) {
      this.openType = 'edit'
      this.disabled = flag
      this.form = {}
      // this.userList = []
      await this.getUserList()
      if (index == 0) {
        this.form = Object.assign({}, record)
        this.form.useMenus = record.useMenus.split(',')
        this.form.useExtractUserIds = record.useExtractUserIds.split(',')
        this.form.useLibraryUserIds = record.useLibraryUserIds.split(',')
        this.form.useMenuUserIds = record.useMenuUserIds.split(',')
      } else {
        getAction('/api/sysexpertlibraryallocationhistory/queryById', { id: record.id }).then((res) => {
          if (res.success) {
            this.form = Object.assign({}, res.result)
            this.form.useMenus = record.useMenus.split(',')
            this.form.useExtractUserIds = record.useExtractUserIds.split(',')
            this.form.useLibraryUserIds = record.useLibraryUserIds.split(',')
            this.form.useMenuUserIds = record.useMenuUserIds.split(',')
          } else {
            return this.$message.error(res.message)
          }
        })
      }
      this.visible = true
      console.log(this.form)
    },
    close() {
      this.$emit('close')
    },
    disabledTime(current) {
      return {
        disabledHours: () => this.getDisabledHours(current || moment(new Date())),
        disabledMinutes: () => this.getDisabledMinutes(current || moment(new Date())),
        disabledSeconds: () => this.getDisabledSeconds(current || moment(new Date()))
      }
    },
    getDisabledHours(date) {
      const hours = []
      for (let i = 0; i < 24; i++) {
        if (moment().isAfter(date.clone().hour(i))) {
          hours.push(i)
        }
      }
      return hours
    },
    getDisabledMinutes(date) {
      const minutes = []
      for (let i = 0; i < 60; i++) {
        if (moment().isAfter(date.clone().minute(i))) {
          minutes.push(i)
        }
      }
      return minutes
    },
    getDisabledSeconds(date) {
      const seconds = []
      for (let i = 0; i < 60; i++) {
        if (moment().isAfter(date.clone().second(i))) {
          seconds.push(i)
        }
      }
      return seconds
    },

    handleOk() {
      this.$refs.ruleForm.validate(async (valid, fields) => {
        if (valid) {
          const that = this
          that.confirmLoading = true
          let formData = this.form
          let obj
          formData.useMenuUserIds = this.form.useMenuUserIds.join(',')
          formData.useLibraryUserIds = this.form.useLibraryUserIds.join(',')
          formData.useExtractUserIds = this.form.useExtractUserIds.join(',')
          formData.useMenus = this.form.useMenus.join(',')
          console.log(formData)

          if (!this.form.id) {
            obj = addZJK(formData)
          } else {
            obj = editZJK(formData)
          }
          obj
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
                that.visible = false
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          for (const obj in fields) {
            if (this.$refs[obj] !== undefined) {
              const dom = this.$refs[obj]
              dom.$el.scrollIntoView({
                // 滚动到指定节点
                block: 'end', // 值有start,center,end，nearest，当前显示在视图区域中间
                behavior: 'smooth' // 值有auto、instant,smooth，缓动动画（当前是慢速的）
              })
            }
          }
          this.confirmLoading = false
          this.$message.error('含有必填项校验失败')
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.$refs.ruleForm.resetFields()
      this.close()
    },
    validateRoleCode(rule, value, callback) {
      if (/[\u4E00-\u9FA5]/g.test(value)) {
        callback('角色编码不可输入汉字!')
      } else {
        var params = {
          // tableName: "sys_role",
          // fieldName: "role_code",
          id: this.model.id,
          roleCode: value,
          appId: this.model.appId
        }
        checkRoleCodeByAppId(params).then((res) => {
          if (res.result) {
            callback()
          } else {
            callback(res.message)
          }
        })
      }
    },
    getInfos() {
      const that = this
      sysInfoall(null).then((res) => {
        if (res.success) {
          const result = res.result
          result.forEach((m) => {
            that.data.push({
              value: m.appId,
              text: m.appCnName
            })
          })
        }
      })
    },
    handleSearch(value) {
      // fetch(value, data => (this.data = data));
    },
    handleChangeuseMenuUserIds(value) {
      this.form.useMenuUserIds = value
    },
    handleChangeuseLibraryUserIds(value) {
      this.form.useLibraryUserIds = value
    },
    handleChangeuseExtractUserIds(value) {
      this.form.useExtractUserIds = value
    },
    handleChange2(value) {
      let fileList = [...value.fileList]
      fileList = fileList.slice(-1)
      console.log(fileList)
      let res = fileList[0].response
      console.log(res)
      if (res) {
        this.iconGroup = res.result.attachGroup
        this.iconUrl = res.result.attachPath
      }
      this.fileAvatarList = fileList
    }
  }
}
</script>

<style scoped></style>
